import React from 'react';
import logoImage from '../../assets/images/Pulc Logos/SVG/pulc_logo_spark_gradient.svg';

const Logo = ({ className = '' }) => {
  return (
    <img 
      src={logoImage} 
      alt="Pulc.ai Logo" 
      className={`logo ${className}`}
    />
  );
};

export default Logo; 